import { MarketLanguageCodes } from '~/sharedInterfaces/SharedEnums';
import { IAvailableMarkets } from '~/sharedInterfaces/SharedInterfaces';

export const getMonthlyEstimate = (
  loanAmount: string,
  term: number,
  market: keyof IAvailableMarkets<MarketLanguageCodes>
) => {
  const euMarkets = ['FI', 'BE', 'NL'];
  const isMarketEU = euMarkets.some((euMarket) => euMarket.toLowerCase() === market);
  const amortisation = Number(loanAmount) / term;
  const value = isMarketEU ? Number(loanAmount) : Number(loanAmount) / 10;
  const scalingRate = 100;

  // const y1 = 1.7475;
  // const y2 = 1.25;
  // const x1 = 1000;
  // const x2 = 200000;

  // (y2 - y1) / (x2 - x1)
  const slope = -0.0000025;

  // y1 - slope * x1
  const intercept = 1.75;
  const interestPercentage = slope * value + intercept;

  const roundedAmortisation = Math.round(amortisation);
  const fee = interestPercentage / scalingRate;
  const roundedFee = isMarketEU ? Math.round(fee * value) : Math.round(fee * value * 10);
  const total = roundedAmortisation + roundedFee;

  return { roundedAmortisation, roundedFee, total };
};

export const formatAmount = (amount: number) => {
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

export const changePrice = (
  loanAmount: string,
  term: number,
  market: keyof IAvailableMarkets<MarketLanguageCodes>
) => {
  const estimatedMonthly = getMonthlyEstimate(loanAmount, term, market);
  const fee = formatAmount(estimatedMonthly.roundedFee);
  const amortisation = formatAmount(estimatedMonthly.roundedAmortisation);
  const total = formatAmount(estimatedMonthly.total);

  return { fee, amortisation, total };
};
